module.exports = __webpack_public_path__ + "img/9788972917328.5fa47e56.jpg";